import { createElement } from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import withStyles, { WithStyles } from 'react-jss';
import { ComponentDesc } from '../../store';
import { FaSortDown } from 'react-icons/fa';
import { FaCaretRight } from 'react-icons/fa';
import { settingsPanelStyles as styles } from './styles';
import { SketchPicker } from 'react-color';
import reactCSS from 'reactcss';
import ReactTooltip from 'react-tooltip';

const link = require('../icons/link.svg');
const broken_link = require('../icons/broken_link.svg');

interface IProps extends WithStyles<typeof styles> {
    descriptor: ComponentDesc<any>;
}

interface IPropsBorderRow {
    name: string;
    field: string;
    className: string;
    descriptor: ComponentDesc<any>;
}

class BorderEdit extends Component<IProps, any> {
    state = {
        isExpanded: false,
        isChecked: false,

        displayColorPicker: false,

        borderColor: {
            r: '0',
            g: '0',
            b: '0',
        },
    };
    handleClickColor = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker });
    };

    handleCloseColor = () => {
        this.setState({ displayColorPicker: false });
    };

    handleChangeColor = (borderColor) => {
        this.props.descriptor.style.borderColor = borderColor.hex;
    };

    updateAllRadius(r) {
        this.props.descriptor.style.borderTopLeftRadius = r;
        this.props.descriptor.style.borderTopRightRadius = r;
        this.props.descriptor.style.borderBottomRightRadius = r;
        this.props.descriptor.style.borderBottomLeftRadius = r;
    }

    EquateAllRadius() {
        this.setState({ isChecked: !this.state.isChecked });
    }

    render() {
        let { descriptor } = this.props;
        const { classes } = this.props;
        const styles = reactCSS({
            default: {
                borderColor: {
                    width: '50px',
                    height: '14px',
                    borderRadius: '2px',
                    background: `rgba(${this.state.borderColor.r}, ${this.state.borderColor.g}, ${this.state.borderColor.b})`,
                },

                swatch: {
                    padding: '5px',
                    background: '#DDDDDD',
                    borderRadius: '1px',
                    boxShadow: '#DDDDDD',
                    display: 'inline-block',
                    cursor: 'pointer',
                    width: 50,
                },
                popover: {
                    position: 'absolute',
                    //  zIndex: '2',
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
                root: {
                    display: 'flex',
                    flexDirection: 'column',
                },
            },
        });

        const BorderRow = ({ name, field, descriptor, className }: IPropsBorderRow) => {
            return (
                <tr>
                    <td>{name}</td>
                    <td>
                        <input type="number" value={descriptor.style[field + 'Width']} onChange={(e) => (descriptor.style[field + 'Width'] = +e.target.value)} className={className + ' borderWidthInputBox'} />
                    </td>
                    <td>
                        <select
                            className={className + ' borderstyleInputBox'}
                            type="text"
                            value={descriptor.style[field + 'Style']}
                            onChange={(e) => (descriptor.style[field + 'Style'] = e.target.value)}
                            style={{
                                color: '#2F343E',
                            }}>
                            <option>Solid</option>
                            <option>Dotted</option>
                            <option>Dashed</option>
                            <option>Double</option>
                            <option>groove</option>
                            <option>inset</option>
                            <option>outset</option>
                            <option>hidden</option>
                            <option>none</option>
                        </select>
                    </td>
                    <td>
                        <div style={styles.swatch} onClick={this.handleClickColor}>
                            <div style={styles.borderColor} className=" borderColor" />
                        </div>
                        {this.state.displayColorPicker ? (
                            <div style={styles.popover}>
                                <div style={styles.cover} onClick={this.handleCloseColor} />
                                <SketchPicker borderColor={this.state.borderColor} onChange={this.handleChangeColor} />
                            </div>
                        ) : null}
                    </td>
                </tr>
            );
        };

        return (
            <div className={classes.root}>
                <div style={{ position: 'relative' }}>
                    <div className={classes.panel}>
                        <span className={classes.header} style={{ width: 114 }}>
                            Border Radius
                        </span>
                    </div>

                    <div>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                //   justifyContent: 'space-around',
                            }}>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    margin: 2,
                                }}>
                                <span className={classes.sub_header}>Top</span>

                                <input type="number" value={descriptor.style.borderTopLeftRadius} onChange={(e) => (this.state.isChecked ? this.updateAllRadius(+e.target.value) : (descriptor.style.borderTopLeftRadius = +e.target.value))} className={classes.input} />
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    margin: 2,
                                }}>
                                <span className={classes.sub_header}>Right</span>
                                <input type="number" value={descriptor.style.borderTopRightRadius} onChange={(e) => (this.state.isChecked ? this.updateAllRadius(+e.target.value) : (descriptor.style.borderTopRightRadius = +e.target.value))} className={classes.input} />
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    margin: 2,
                                }}>
                                <span className={classes.sub_header}>Bottom</span>
                                <input type="number" value={descriptor.style.borderBottomLeftRadius} onChange={(e) => (this.state.isChecked ? this.updateAllRadius(+e.target.value) : (descriptor.style.borderBottomLeftRadius = +e.target.value))} className={classes.input} />
                            </div>

                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    margin: 2,
                                }}>
                                <span className={classes.sub_header}>Left</span>
                                <input type="number" value={descriptor.style.borderBottomRightRadius} onChange={(e) => (this.state.isChecked ? this.updateAllRadius(+e.target.value) : (descriptor.style.borderBottomRightRadius = +e.target.value))} className={classes.input} />
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    margin: 2,
                                }}>
                                <span className={classes.sub_header}>All</span>
                                <button data-for="link" title="Link Values" onClick={() => this.EquateAllRadius()}>
                                    {this.state.isChecked ? <img src={link} /> : <img src={broken_link} />}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(observer(BorderEdit));
